<div
  class="ui-radio"
  [class.ui-radio--checked]="checked()"
  [class.ui-radio--disabled]="disabled()"
  [class.ui-radio--invalid]="invalid()"
>
  <label class="ui-radio__row" [attr.for]="inputId()">
    <!-- Input nativo sr-only -->
    <input
      class="ui-radio__input"
      type="radio"
      [id]="inputId()"
      [attr.name]="name() ?? null"
      [attr.value]="value() ?? null"
      [checked]="checked()"
      [disabled]="disabled()"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy()"
      (change)="onChange($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    />

    <!-- Círculo visual (siempre en DOM, CSS controla estado) -->
    <span class="ui-radio__circle" aria-hidden="true">
      <!-- Punto interior — visible solo cuando checked -->
      <span class="ui-radio__dot"></span>
    </span>

    <!-- Label + descripción + badge -->
    @if (label() || description()) {
      <span class="ui-radio__content">
        @if (label()) {
          <span class="ui-radio__label">
            {{ label() }}
            @if (showRequirement()) {
              <span
                class="ui-radio__requirement"
                [class.ui-radio__requirement--error]="invalid() && required()"
                aria-hidden="true"
              >
                {{ requirementText() }}
              </span>
            }
          </span>
        }
        @if (description()) {
          <span class="ui-radio__description" [id]="inputId() + '-desc'">
            {{ description() }}
          </span>
        }
      </span>
    }
  </label>

  @if (message() && invalid() && showMessage()) {
    <p class="ui-radio__message" [id]="messageId()" role="alert">
      {{ message() }}
    </p>
  }
</div>
